import React from "react";
import { SUNGSU_TILESET_ADJUST_HEIGHT } from "../../constants";
import useViewStore from "../../stores/viewer.store";

export default function useApplyViewModel({
  show,
  modelPath,
}: {
  show: boolean;
  modelPath?: string;
}) {
  const { setTilsets } = useViewStore();

  React.useEffect(() => {
    if (!show || !modelPath) return;

    setTilsets([]);

    setTilsets([
      {
        path: modelPath,
        adjustHeight: SUNGSU_TILESET_ADJUST_HEIGHT,
      },
    ]);

    // eslint-disable-next-line consistent-return
    return () => {
      setTilsets([]);
    };
  }, [modelPath, setTilsets, show]);
}
